"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HolyDuration = void 0;
const time_1 = require("./time");
class HolyDuration {
    milliseconds;
    constructor(time) {
        this.milliseconds = time;
    }
    static getUnit(unit) {
        const unitKey = unit.toUpperCase().slice(0, -1);
        if (!time_1.HolyTime.Units.hasOwnProperty(unitKey)) {
            throw new Error(`Invalid unit: ${unit}`);
        }
        return time_1.HolyTime.Units[unitKey];
    }
    add(amount, unit = 'milliseconds') {
        this.milliseconds += amount * HolyDuration.getUnit(unit);
        return this;
    }
    subtract(amount, unit = 'milliseconds') {
        return this.add(-amount, unit);
    }
    in(unit) {
        return this.milliseconds / HolyDuration.getUnit(unit);
    }
}
exports.HolyDuration = HolyDuration;
